React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
track = require 'debug/track'

class OrgBCSettingsComponent extends React.Component
  @displayName: 'OrgBCSettingsComponent'

  render: t.renderable ->
    { items, isAdmin, hasBC, billingUrl, upsellEnabled, hasEnterprise } = @props

    fnTrackMore = (e) ->
      if e.target.getAttribute("href") == '/business-class'
        track("Organization View", "Settings Page", "A Whole Lot More Link")

    fnTrackBC = ->
      track("Organization View", "Settings Page", "Upgrade My Team Button")

    t.div ->
      if hasBC
        t.div ->
          items.forEach(t.addElement)
      else if !hasEnterprise && upsellEnabled
          t.div '.org-bc-settings.ads-layout-experiment', ->
            t.div '.org-bc-settings-ad', onClick: fnTrackMore, ->
                t.div '.org-bc-settings-ad-logo', ->
                  t.img  { src: require('images/business-class-logo-white.svg') }
                t.div '.org-bc-settings-ad-body', ->
                  t.p '.org-bc-settings-ad-title', ->
                    t.format 'ads-title'
                  t.p '.org-bc-settings-ad-text', ->
                    t.format 'ads-text'
                  t.a '.org-bc-settings-ad-learn-more', { href: '/business-class', target: '_blank' }, ->
                    t.format 'ads-learn-more'

                  if isAdmin
                    t.a '.button.primary', { href: billingUrl, onClick: fnTrackBC }, ->
                      t.format 'ads-upgrade'
                  else
                    t.p '.org-bc-settings-ad-ask-to-upgrade', ->
                      t.format 'seem-helpful-ask-your-team-admin-to-consider-upgrading-your-team'

            t.div '.org-bc-body', ->
              items.forEach(t.addElement)
        else if !hasEnterprise && upsellEnabled
          t.div '.org-bc-settings', ->
            t.div '.org-bc-settings-header', onClick: fnTrackMore, ->
              t.span ->
                t.img  { src: require('images/business-class-logo-blue.svg') }
              t.br()
              t.format 'upgrade-to-trello-business-class-to-unlock-these-settings'
              t.br()
              if isAdmin
                t.link billingUrl, '.button-link.primary', onClick: fnTrackBC, ->
                  t.format 'upgrade-my-team'
              else
                t.br()
                t.format 'seem-helpful-ask-your-team-admin-to-consider-upgrading-your-team'

              items.forEach(t.addElement)

module.exports = OrgBCSettingsComponent



// WEBPACK FOOTER //
// ./app/scripts/views/organization/org-bc-settings-component.coffee